import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { ActionType, useI18n, useToast } from '@nosinovacao/nosid-mfe-common';
import { useNavigate } from '@tanstack/react-router';

export function useRemoveServiceAccess() {
  const navigate = useNavigate();
  const toast = useToast();
  const { t } = useI18n();
  return useNosIdMutation({
    mutationFn: async () =>
      api.delete('/api/v1/users/secondary/:userId', { params: { userId: '' } }),
    successLogAction: () => ({
      ActionType: ActionType.DeleteSecondaryUserAssociation,
    }),
    errorLogAction: () => ({
      ActionType: ActionType.DeleteSecondaryUserAssociation,
    }),
    onSuccess: (_result, _variables, _mutateResult, { client }) => {
      toast.show('success', t('Common.SnackBar.RemoveServiceAccess'));
      client.resetQueries();
      navigate({ to: '/home' });
    },
  });
}
